export const START_LOAD = 'carValues/START_LOAD';
export const FINISH_LOAD = 'carValues/FINISH_LOAD';

const initialState = {
    loading:false,
    carValues:null
};
export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case START_LOAD:  return {...state, loading:true};
        case FINISH_LOAD:  return {...state, loading:false, carValues:action.payload};
        default: return state;
    }
}